module.exports = __webpack_public_path__ + "fonts/Inter-700-cyrillic-ext64.857026d.woff2";